<app-breadcrumb [title]="'Districts'"></app-breadcrumb>
<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="card mb-3">
        <div class="card-header border-0">
          <div class="d-flex justify-content-end">
            <a [routerLink]="['/admin/regions/states/districts/new']" class="btn btn-primary rounded-0">New
              District</a>
          </div>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-2">
              <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.regionId" #regionId="ngModel"
                (change)="getStates($event.target.value)">
                <option value="" selected>--SELECT REGION--</option>
                <option *ngFor="let item of regions" [value]="item.value">{{ item.text }}
                </option>
              </select>
            </div>
            <div class="col-2">
              <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.stateId" #stateId="ngModel">
                <option value="" selected>--SELECT STATE--</option>
                <option *ngFor="let item of states" [value]="item.value">{{ item.text }}
                </option>
              </select>
            </div>
            <div class="col-2">
              <input type="text" class="form-control" placeholder="Name" [(ngModel)]="query.name"
                #name="ngModel" />
            </div>
            <div class="col-2">
              <button type="button" class="btn btn-success" (click)="filter()">Search</button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div *ngIf="queryResult.items" class="table-responsive">
            <table class="table align-items-center table-hover">
              <colgroup>
                <col style="width: 20%">
                <col style="width: 20%">
                <col style="width: 20%">
                <col style="width: 20%">
                <col style="width: 20%">
              </colgroup>
              <thead class="table-light">
                <tr>
                  <th *ngFor="let c of columns">
                    <div *ngIf="c.isSortable" (click)="sortBy(c.key)">
                      <div class="d-flex justify-content-between align-items-center">
                        {{ c.title }}
                        <div class="ml-2">
                          <i-bs *ngIf="query.sort === c.key" [name]="query.sortDir == 'Ascending' ? 'arrow-up' : 'arrow-down'" width="1em" height="1em"></i-bs>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="!c.isSortable">
                      {{ c.title }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let v of queryResult.items; let i=index;">
                  <td>{{ (queryResult.pageSize * queryResult.pageNumber + i) - 9 }}</td>
                  <td>{{ v.name }}</td>
                  <td>{{ v.state?.name }}</td>
                  <td>{{ v.state?.region?.name }}</td>
                  <td>
                    <a class="btn btn-sm btn-icon-only"
                      [routerLink]="['/admin/regions/states/districts/edit', v.id]"><span
                        class="material-icons">edit</span></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <pagination [total-rows]="queryResult.totalRows" [current-page]="query.page" [page-size]="query.pageSize">
          </pagination>
        </div>
      </div>
    </div>
  </div>
</div>